export default __webpack_public_path__ + "static/Difi.io_v4-01-422eb1c5c68dc6c203cdcce44bda4e6c.jpg";